





















































































































































































































































import Vue from 'vue'
import api from '../../../api'
import ReimbursementKkiapayVerificationModal from './ReimbursementKkiapayVerificationModal.vue'

export default Vue.extend({
  components: {
    ReimbursementKkiapayVerificationModal
  },
  props: {
    credit: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      loading: false,
      error: null as string | null,
      data: null as any,
      showKkiapayModal: false,
      selectedReimbursement: null as any
    }
  },

  methods: {
    formatAmount(amount: number): string {
      return new Intl.NumberFormat('fr-FR').format(amount || 0)
    },

    formatDate(date: string): string {
      if (!date) return '-'
      return new Date(date).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      })
    },

    getStateLabel(state: string): string {
      const labels: Record<string, string> = {
        paid: 'Payé',
        pending: 'En attente',
        failed: 'Échec'
      }
      return labels[state] || state
    },

    async loadReimbursements() {
      this.loading = true
      this.error = null
      try {
        const response = await api.get(
          `/dispatching-credits/${this.credit.id}/reimbursements`
        )
        this.data = response.data
      } catch (err) {
        this.error =
          err.response?.data?.message ||
          'Erreur lors du chargement des remboursements'
      } finally {
        this.loading = false
      }
    },

    verifyReimbursementTransaction(reimbursement: any) {
      this.selectedReimbursement = reimbursement
      this.showKkiapayModal = true
    }
  },

  mounted() {
    this.loadReimbursements()
  }
})
